import { Component, EventEmitter, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { TypedFormBuilder } from '../../../../form/TypedFormBuilder';
import { Validators } from '@angular/forms';
import { translationProvider } from '@ui/nls/translations/translate.directive';

@Component({
    selector: 'lib-new-project-name',
    templateUrl: './new-project-name.component.html',
    styleUrls: ['./new-project-name.component.scss'],
    providers: [translationProvider('productFront')],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class NewProjectNameComponent implements OnInit {
  @Input() model = this.fb.typedGroup<{ name: string }>({
    name: ['', [Validators.required, Validators.minLength(3)]],
  });

  saved = new EventEmitter<string>();

  constructor(private fb: TypedFormBuilder) {}

  ngOnInit(): void {}

  submit() {
    this.model.markAllAsTouched();

    if (this.model.valid) {
      this.saved.emit(this.model.value.name);
    }
  }

  skip() {
    this.saved.emit();
  }
}
